import { Text } from 'farmhub-ui-core';

import { TickIcon } from 'components/Icon';

import { Image, Wrapper } from './styles';

type CertificationSelectedProps = {
  image: string;
  title: string;
  selected: boolean;
};

const CertificationSelected = ({
  image,
  title,
  selected,
}: CertificationSelectedProps) => (
  <Wrapper selected={selected}>
    <Image src={image} />
    <Text
      color="primary"
      lineHeight="16px"
      lineNumber={3}
      size="xxs"
      styles={{ display: 'block', textAlign: 'center' }}
      weight="bold"
    >
      {title}
    </Text>
    <div className="tick">
      <TickIcon color="#fff" width={12} />
    </div>
  </Wrapper>
);

export default CertificationSelected;
